import type { HttpErrorResponse } from '@angular/common/http';
import type { ApolloError } from '@apollo/client/errors';

export interface ErrorData {
  error: string;
  code?: number;
  data?: unknown;
}

const errorCodes: Record<number, string> = {
  1001: '[%s] is not compatible with current configurator!',
};

export const getErrorDataByCode = (
  code: number,
  data: unknown,
): ErrorData | null => {
  if (!Object.keys(errorCodes).includes(code.toString())) {
    return null;
  }

  return { error: errorCodes[code], code, data };
};

export const getErrorMessage = (
  error: unknown,
  fallbackMessage = 'An unexpected error occurred',
): ErrorData => {
  const apolloError = error as ApolloError;

  const graphQLError = apolloError?.graphQLErrors?.[0];
  const networkError = apolloError?.networkError as HttpErrorResponse;

  const errorCode = graphQLError?.extensions?.['code'];
  const errorData =
    !!graphQLError && 'data' in graphQLError ? graphQLError?.['data'] : null;

  const getErrorData = getErrorDataByCode(
    typeof errorCode === 'number' ? errorCode : 0,
    errorData,
  );

  return (
    getErrorData || {
      error:
        graphQLError?.message ||
        networkError?.error?.errors?.[0]?.message ||
        networkError?.message ||
        fallbackMessage,
    }
  );
};
